import React from 'react'

import classes from './RadioButton.module.css';

import iconRadioActiveBlue from '../../../../assets/icons/radio-button-active-blue.png';
import iconRadioInactiveBlue from '../../../../assets/icons/radio-button-inactive-blue.png';


// Props List :-
// active = to handle styles if this radio button is the active one in the group
// clicked = the function that handles radio button click
// label = the label for radio button

const radioButton = (props) => {
    //Log(props);
    return (
        <div className={[classes.RadioButton, props.active ? classes.active : null].join(' ')} onClick={props.clicked}>
            <img
                className={classes.RadioImage}
                alt='Radio Active'
                src={props.active ? iconRadioActiveBlue : iconRadioInactiveBlue}
            />
            <p className={props.forNewDailyFeedbackPopup ? classes.RadioButtonLabel1 : classes.RadioButtonLabel}>{props.label}</p>
        </div>
    );
}

export default radioButton;